<template>
<div class="chapter">
<div class="inner_page">
<h2 id="c5"><span class="calibre1">CHAPTER V</span>
<br class="calibre8"/>
<span class="h2line">MAN OVERBOARD!</span></h2>
<p class="calibre3">Several other reporters gathered about Larry,
who stood blushing at the attention he was attracting.
He hardly knew whether to accept the
money or not. One of his fellow newspaper workers
saw his confusion.</p>
<p class="calibre3">“Take it,” he whispered. “It’s all in the game,
and you won it fairly. I’ll keep it for you until
you get dressed.”</p>
<p class="calibre3">Larry accepted the offer, and gave the money
to his friend, who put it in his pocket until the
lad had his clothes on once more.</p>
<p class="calibre3">There were a number of other games and
sports after this, and then the members of the
club, thoroughly tired out with the day’s fun,
went aboard the boat for the trip home. There
was not much excitement on the way back, and
Larry was beginning to fear he might have
missed the story.</p>
<p class="calibre3">He thought perhaps there had been politics
talked which he had not overheard, and he was
worried lest Mr. Emberg would think he had not
properly covered the assignment.</p>
<div class="calibre2" id="Page_37" title="37"></div>
<p class="calibre3">Larry ventured to hint at this to some of the
other reporters, but they all told him that, contrary
to all expectations, there had been no politics
worth mentioning discussed on the outing.</p>
<p class="calibre3">“Just make a general story of it,” advised the
reporter who had held the money for Larry.
“None of us are looking for a beat.”</p>
<p class="calibre3">So Larry made his mind easier. A little later
the boat made a stop at a dock to let off several
members who had decided to go the rest of the
way home by train. The newspaper men, with
the exception of Larry, decided, also, to go home
on the railroad.</p>
<p class="calibre3">“Better come along,” they said to Larry.
“You’ll get no more story.”</p>
<p class="calibre3">“Probably not,” rejoined Larry, “but I’ll stay
just the same. The boss told me to keep on the
job until it was over, and it isn’t over until the
boat ties up at the last dock.”</p>
<p class="calibre3">“You’ll soon get over that nonsense,” said the
reporter, with a laugh, as he left the craft. The
boat resumed her way up the river, and Larry,
who was quite tired out, was beginning to think
he was to have his trouble for his pains in explicitly
following instructions. There seemed no
more chance for news, since most of the men
were resting comfortably in chairs, or lounging
half-asleep in the cabins. Even the band was too
tired to play.</p>
<p class="calibre3">It was getting dusk, and Larry was wondering
what time he would get home. He walked about
the upper deck, and gazed off across the water.</p>
<div class="calibre2" id="Page_38" title="38"></div>
<p class="calibre3">Suddenly there sounded a commotion on the
deck below him. Then came a splash in the
water.</p>
<p class="calibre3">“Man overboard! Man overboard!” sung out
several deckhands. “Lower a boat!”</p>
<p class="calibre3">At once the steamer was the scene of confusion.
Men were running to and fro, a hurried
jangle of bells came from the engine room, and
the craft slackened speed.</p>
<p class="calibre3">“Turn on the searchlight!” cried someone, and
soon the beams from the big glaring beacon were
gleaming on the dark waters aft the boat.</p>
<p class="calibre3">“There he is, I see his head!” cried someone
at the stern, casting a life buoy toward the figure
of the man who had toppled over the rail.</p>
<p class="calibre3">“Who is it?”</p>
<p class="calibre3">“Who threw him in?”</p>
<p class="calibre3">“How did it happen?”</p>
<p class="calibre3">“Is he dead?”</p>
<p class="calibre3">These were a few of the confused cries that
came from all parts of the steamer. But while
most of the excursionists were greatly excited, the
members of the crew of the craft remained calm.
They quickly lowered a boat, and, by the aid of
the glare from the searchlight, were able to pick
out the swimming figure of the man. They
headed the boat toward him, and in a little while
hauled him into the small skiff. Then they rowed
back to the steamer, the rail of which was
crowded with anxious friends of the unlucky
one.</p>
<div class="calibre2" id="Page_39" title="39"></div>
<p class="calibre3">“Did you save him?” they cried, for they could
not see whether their friend was in the boat or
not.</p>
<p class="calibre3">“Sure!” cried several of the crew, and one
added: “He’s all the better for a little salt water!”</p>
<p class="calibre3">“This will make a good part of the story,”
thought Larry, as he watched the craft drawing
nearer. “I guess the other fellows will wish they
had stayed aboard.”</p>
<p class="calibre3">When the skiff reached the steamer, and the
crew, and rescued one, had been taken aboard,
there were scores of demands to know how it all
happened.</p>
<p class="calibre3">“I’ll tell you,” said the victim of the accident.
“I was sleeping on two camp-stools close to the
rail. I got to dreaming I was making a political
speech, and I was walking up and down the platform
telling the audience what a fine party the
Democratic one is.</p>
<p class="calibre3">“I must have walked a little too far, for, the
first thing I knew, I had stepped over the edge
of the platform, and the next thing I knew I was
falling. I woke up in the river, and struck out.
That’s about all.”</p>
<p class="calibre3">“Lucky for you the searchlight was working,”
remarked one of the man’s friends, “or you
might have been on the bottom of the river by
now.”</p>
<div class="calibre2" id="Page_40" title="40"></div>
<p class="calibre3">“Well, you see,” said the man, with a smile,
as he wiped the water from his eyes. “I ate so
many clams, lobsters, and crabs to-day that when
I got down there the river thought I was a sort
of a fish, and so it didn’t drown me.”</p>
<p class="calibre3">Larry made inquiry, and found out the man’s
name. He made notes of the occurrence, and,
the next morning, on reaching the office, wrote
up a lively story of the happening.</p>
<p class="calibre3">He said nothing to Mr. Emberg about being
the only reporter on the boat when the thing happened.
But that afternoon, when all the other
papers came out, and, like the morning issues,
had no account of the rescue of the man, who
was a prominent politician, the city editor said:</p>
<p class="calibre3">“I hope you weren’t ‘faking’ that story,
Larry?” and Mr. Emberg looked serious, for he
did not want any of the reporters to “fake,” or
write untrue accounts of matters.</p>
<p class="calibre3">“No, sir, it actually happened,” said Larry,
and he related how he came to be the only newspaper
reporter at the scene. A little later Mr.
Newton came in.</p>
<p class="calibre3">“Say,” he asked, “did we have a story of a
man falling overboard on that Democratic outing?
I just heard of it on the street as I was
coming in.”</p>
<p class="calibre3">He had not been in that morning, being out
of town on a story.</p>
<p class="calibre3">“Oh, Larry was on hand as usual,” replied the
city editor, for by this time he was convinced
that Larry’s account was true. “He has given us
another beat.”</p>
<div class="calibre2" id="Page_41" title="41"></div>
<p class="calibre3">And so it proved, for the <i class="calibre9">Leader</i> was the only
paper in New York that had an account of the
incident, and nearly all of the later editions of
the afternoon sheets had to use the story, copying
it from the <i class="calibre9">Leader</i>.</p>
<p class="calibre3">“It was a good beat, and a good story of the
outing besides,” said Mr. Emberg, shortly after
the last edition had gone to press, for he liked
the half-humorous manner in which Larry had
written about the sack race and the other sports
in which the members of the club had indulged.
“You are doing fine work,” he added, at which
praise Larry felt much gratified.</p>
<p class="calibre3">Things were slacking up a bit in the office, now
that the paper had gone to press for the day,
when one of the reporters who was looking over
the front page suddenly cried out:</p>
<p class="calibre3">“Here’s a bad mistake in that account of the
meeting of the County Republican Committee
last night. It says Jones voted for Smith for
chairman, and that’s wrong. I was there. The
compositor must have made a mistake. It ought
to be corrected, or it will make trouble.”</p>
<p class="calibre3">“I’m afraid it’s too late,” remarked Mr. Emberg,
as he grabbed a paper to see the error.
“The presses are running, and part of the last
edition is off. The only way we can do is to
have them smash Jones’s name, and blur it so no
one can tell what it is. That’s what I’ll do.”</p>
<p class="calibre3">He tore part of the page off, marked out the
name to be smashed, and called to Larry, there
being no copy boys in the room then:</p>
<div class="calibre2" id="Page_42" title="42"></div>
<p class="calibre3">“Here, Larry, go down in the pressroom, and
tell Dunn, the foreman, to smash that name.”</p>
<p class="calibre3">Though Larry had been on the paper some
time he had never been in the pressroom. Nor
did he know what the operation of smashing a
name might mean, but he decided the best thing
to do would be to carry the message.</p>
<p class="calibre3">He hurried down to the basement. As soon
as he opened the door leading to it, down a steep
flight of steps, Larry thought he had gotten into
a boiler factory by mistake. The noise was
deafening, and the presses were thundering away
like some giant machine grinding tons of rocks
to atoms.</p>
<p class="calibre3">Half-naked men were running about here and
there. In one corner was a furnace full of melted
lead for making the stereotype plates. Larry
made his way through the maze of wheels, machinery,
and presses.</p>
<p class="calibre3">He was met by a youth whose face was covered
with ink.</p>
<p class="calibre3">“Where’s Mr. Dunn?” asked Larry, shouting
at the top of his voice.</p>
<p class="calibre3">The youth did not bother to answer in words.
He had been in the pressroom long enough to
know the uselessness of trying to make himself
heard above the din. He had understood Larry’s
question from watching his lips, and pointed over
in one corner.</p>
<p class="calibre3">There Larry found a quiet man marking something
in a book.</p>
<div class="calibre2" id="Page_43" title="43"></div>
<p class="calibre3">“Mr. Emberg says to smash that name!” yelled
the boy, handing over the paper. He was afraid
he had not made himself heard, but Mr. Dunn
seemed to comprehend, for he nodded several
times, though he did not seem pleased. He hated
to stop the presses, once they were running, until
all the edition was off.</p>
<p class="calibre3">However, it had to be done. He left his corner,
and went around the rear of the ponderous
machine, where the paper, in a large roll, was
fed in at one end, to emerge, folded and printed
sheets, at the other. Mr. Dunn seized a rope, and
yanked it. A bell rang, and the press began to
slacken up.</p>
<p class="calibre3">The type from which the paper was printed
was cast in one solid sheet, there being several
of the sheets, just the size of a page. Each one
was half-circular, and fitted around a cylinder on
the press. This cylinder whirled around, and
the paper, passing under it in a continuous roll,
received the impressions.</p>
<p class="calibre3">Once the press was stopped Mr. Dunn crawled
up into a sort of hole in front of the cylinder,
Then he had the press worked slowly, until
the particular page he had to reach came into
view.</p>
<div class="calibre2" id="Page_44" title="44"></div>
<p class="calibre3">Next, with a hammer and chisel he smashed
the name of Jones so that it was a meaningless
blur. After that the press started its thundering
again. The remainder of the papers would not
contain the name of Jones, and so there would
be no danger of that gentleman coming in and
demanding an apology for a misstatement made
about him. Often papers have to resort to this
emergency when it is too late to correct directly
in type an error that has been made.</p>
<div class="calibre2" id="Page_45" title="45"></div>
<div class="pg-boilerplate" id="calibre_pb_4"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0009.vue?794709a0